function HasClass( el, cls )
{
    var current = el.getAttribute( "class" );
    return ( ( current != undefined ) && ( current.indexOf( cls ) != -1 ) );
}

function AddClass( el, cls )
{
    if ( el )
    {
        var current = el.getAttribute( "class" );
        if ( ( current == undefined ) || ( current.indexOf( cls ) == -1 ) )
        {
            current += " " + cls;
            el.setAttribute( "class", current );
        }
    }
}
function RemoveClass( el, cls )
{
    if ( el )
    {
        var current = el.getAttribute( "class" );
        if ( current )
        {
            current = current.replace( cls, ' ' );
            el.setAttribute( "class", current );
        }
    }
}
function SearchParentsFor( start, cls, top )
{
    var result;

    var parent = start.parentNode;
    if ( ( parent ) && (  parent.getAttribute ) )
    {
        var pcls = parent.getAttribute( "class" );
        if ( pcls )
        {
            var pclsArray = pcls.split( " " );
            for ( var i = 0; i < pclsArray.length; i++ )
            {
                if ( pclsArray[ i ] == cls )
                {
                    result = parent;
                    break;
                }
            }
        }

        if ( ( !result ) && ( ( !top ) || ( parent != top ) ) )
        {
            result = SearchParentsFor( parent, cls, top );
        }
    }

    return ( result );
}

function ParseQP( )
{
    var qpd   = { };
    var qp    = window.location.search.substr( 1 );
    var pairs = qp.split( "&" );

    for ( var i = 0; i < pairs.length; i++ )
    {
        var tuple = pairs[ i ].split( "=" );
        if ( ( tuple ) && ( tuple.length == 2 ) )
        {
            var key  = tuple[ 0 ];
            var val  = tuple[ 1 ];
            qpd[ key ] = decodeURIComponent( val );
        }
    }

    return ( qpd );
}

function stopPropagation( e )
{
    if( e )
    {
        e.preventDefault();
        e.stopPropagation();
    }
    else
    {
        window.event.preventDefault();
        window.event.stopPropagation();
    }
}

function SendAPIRequest( url, method, params, cb )
{
    var xhr = new XMLHttpRequest( );   

    xhr.onreadystatechange = function( )
    {
        if ( xhr.readyState == 4 )
        {
            //console.log( "rx response " + xhr.responseText );
            if ( cb )
            {
                var parsed;

                var ct = xhr.getResponseHeader( "Content-Type" );
                if ( ( ct ) && ( ct.indexOf( "json" ) >= 0 ) && ( xhr.responseText ) )
                {
                    try
                    {
                        parsed = JSON.parse( xhr.responseText );
                    }
                    catch ( e )
                    {
                        console.log( "error parsing JSON response : " + e.stack );
                    }
                }

                cb( xhr, parsed );
            }
            else
            {
                if ( xhr.status == 200 )
                {
                    window.location.reload( );
                }
            }
        }
    };

    //console.log( "requesting " + method + " from " + url );
    if ( params )
    {
        xhr.open( method, url, true );
        xhr.setRequestHeader( "Content-Type", "application/json" );
        xhr.send( JSON.stringify( params ) );
    }
    else
    {
        xhr.open( method, url, true );
        xhr.send( );
    }
}

function UnHideSlickSliders()
{
    var hiddenSlickSliders = document.querySelectorAll( ".hidden-slide-until-loaded" );
    for( var i = 0; i < hiddenSlickSliders.length; i++ )
    {
        var hiddenSlickSlider = hiddenSlickSliders[ i ];
        hiddenSlickSlider.classList.remove( "hidden-slide-until-loaded" );
        // RemoveClass( hiddenSlickSlider, "hidden-slide-until-loaded" );
    }
}


window.addEventListener( "load", function( e )
{
    UnHideSlickSliders();
    // initMenuToggle();
} );